module.exports = __webpack_public_path__ + "static/media/professionnalisation.b056262a.jpg";